import React, { useState, useRef } from "react";
import ReactSelect, { components } from "react-select";
import SearchIcon from "@mui/icons-material/Search";
import { FormControl } from "@mui/material";

const SearchBar = ({
  searchIcon,
  clearSearchBar,
  dataArray,
  onChange,
  inputRef,
  placeholder,
  isClearable,
  label,
  disabled,
  handleInputChange,
  sx = {},
}) => {
  const isDark = sx?.darkMode === true;

  const selectStyles = {
    menu: (styles) => ({
      ...styles,
      position: "absolute",
      minWidth: "100%",
      boxShadow: "0 20px 54px 0 rgba(0,0,0,0.2)",
      zIndex: 20,
      margin: 0,
      fontSize: "14px",
      ...(isDark && {
        backgroundColor: "#1e1e2e",
        color: "#ffffff",
      }),
    }),
    control: (Colstyles, state) => ({
      ...Colstyles,
      borderRadius: "5px",
      minHeight: "2.25rem",
      overflow: "clipped",
      whiteSpace: "nowrap",
      flexWrap: "nowrap",
      margin: 0,
      fontSize: "14px",
      minWidth: "100%",
      ...(isDark && {
        backgroundColor: "#1e1e2e",
        borderColor: "#444",
        color: "#ffffff",
      }),
    }),
    input: (provided, state) => ({
      ...provided,
      margin: 0,
      fontSize: "14px",
      overflow: "clip",
      ...(isDark && { color: "#ffffff" }),
    }),
    singleValue: (provided) => ({
      ...provided,
      ...(isDark && { color: "#ffffff" }),
    }),
    option: (provided, state) => ({
      ...provided,
      ...(isDark && {
        backgroundColor: state.isFocused ? "#2a2a3e" : "#1e1e2e",
        color: "#ffffff",
      }),
    }),
    placeholder: (provided) => ({
      ...provided,
      ...(isDark && { color: "#aaaaaa" }),
    }),
  };

  if (isClearable !== false) {
    isClearable = true;
  }
  const [inputValue, setInputValue] = useState("");
  const selectInputRef = useRef();

  const onClear = () => {
    setInputValue("");
  };

  const handleOnChange = (e) => {
    setInputValue("");
    onChange(e);
    if (clearSearchBar) {
      selectInputRef.current.select?.clearValue();
      selectInputRef.current.focus();
      selectInputRef.current.setState({ menuIsOpen: true });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      console.log("do validate", selectInputRef.current);
      selectInputRef.current.select?.focus();
    }
  };

  const handleChange = (string, InputActionMeta) => {
    const { action, prevInputValue } = InputActionMeta;
    handleInputChange(string);
    if (action !== "input-blur" && action !== "menu-close") {
      setInputValue(string);
    }
  };

  const handleInputChangeFunc = (string, action) => {
    if (action.action !== "input-blur" && action.action !== "menu-close") {
      console.log(string);
      handleInputChange(string);
      setInputValue(string);
    }
  };

  return (
    <div className="w-full">
      <FormControl fullWidth>
        <label
          className={
            disabled
              ? "bg-gray-100 absolute text-[#073763] text-[11px] left-[10px] px-1 z-10"
              : "absolute text-[#073763] text-[11px] left-[10px] bg-white px-1 z-10"
          }
          style={{
            bottom: "29px",
            left: "6px",
            ...(isDark && { color: "#90caf9", backgroundColor: "transparent" }),
          }}
        >
          {placeholder}
        </label>
        <ReactSelect
          inputValue={inputValue}
          ref={selectInputRef}
          onKeyDown={handleKeyDown}
          options={dataArray}
          isDisabled={disabled}
          placeholder={placeholder}
          openMenuOnClick={false}
          isClearable={isClearable}
          inputRef={inputRef}
          clearValue={true}
          styles={selectStyles}
          components={{
            DropdownIndicator: () =>
              searchIcon ? (
                <SearchIcon className="mr-4 text-slate-500" />
              ) : null,
            IndicatorSeparator: () => null,
          }}
          autoFocus={true}
          onInputChange={handleInputChangeFunc.bind(this)}
          onChange={handleOnChange}
          blurInputOnSelect
          controlShouldRenderValue={!clearSearchBar}
        />
      </FormControl>
    </div>
  );
};

export default SearchBar;